module.exports = __webpack_public_path__ + "img/logo-en.d7f2b288.png";